
@if (title() && durationMinutes()) {
  <main class="card__main">
    <span class="card__index">
      {{ indexCard() + 1 }}
    </span>
      
    <h2 
      [style.view-transition-name]="'point-title-' + id()"
      class="card__title"
      [class.card__title--one-line]="isDuration15Minutes()"
    >
      {{ title() | translate }}
    </h2>
  </main>
}